export { m as CALCULATE_PREMIUM, z as CHARACTER_LIMIT_LIST, B as COVER_TYPE_LIMIT, N as CROSS_SELL_ROLE_LIMIT, t as CUSTOMER_DROPDOWN_DETAILS, C as CaptureHealthDetails, d as CopyQuote, F as DATE_RANGE, O as EXCEPTION_ROLE_LIMIT, R as EXISTING_POLICY_DTLS, J as FETCH_ROLE, s as GET_CUSTOMER_TYPE_DOMAIN, l as GET_PLAN_COVER_DETAILS, k as GET_PRODUCT_DETAILS, G as GetFieldUserName, y as INTERMEDIARY_LIST, I as ImportQuoteModal, H as LOB_PRODUCT_LIST, L as LOOKUP_FIELDUSER, A as MOBILE_NUMBER_STARTING_WITH, M as Members, e as ModalAddOthers, f as ModalSaveQuote, g as ModalSendEmail, h as ModalSendSms, j as PIN_CODE_LOOKUP, p as PREDICT_HEALTH_PLAN, x as PRODUCT_TYPE_LIST, P as Plans, i as QUERY_STATE, E as QUOTE_STATUS_LIST, b as QuoteData, Q as QuoteSummary, a as QuoteWizard, o as SAVE_PLAN_PREDICTION_DATA, n as SAVE_QUOTE, K as SAVE_QUOTE_TYPE, q as SEARCH_CUSTOMERS, r as SEARCH_CUSTOMER_BY_NUMBER, D as SEARCH_QUOTES, u as SEND_QUOTE_EMAIL_ALERT, w as SEND_QUOTE_PDF, v as SEND_QUOTE_SMS_ALERT, S as ShowPlans, c as ShowPremium, V as VIEW_QUOTE_HEALTH } from '../index-1718b50e.js';
export { C as ChooseProduct, S as SelectProduct } from '../index-e4c98166.js';
export { C as CHECK_IMD_CONFIG, G as GET_LOB_PRODUCTLIST, I as IMD_RECEIPT_LOCK } from '../queries-39e034f7.js';
import React, { useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import { L as Loading } from '../loading-c16d3bd3.js';
import { E as Error } from '../error-ee5266a9.js';
import { e as _taggedTemplateLiteral, c as _slicedToArray } from '../_rollupPluginBabelHelpers-fb970440.js';
import { useResponsiveParams, QuantaFormik, QuantaForm, Grid, QuantaInput, QuantaSelect, GridItem, Button, Modal, DataGrid } from 'quanta-ui';
import { u as updateIntermediary } from '../exports-166cdf01.js';
import { P as Parse } from '../CurrencyFormater-d288bc4f.js';
import 'react-router-dom';
import '../layout.js';
import 'react-helmet';
import '@fortawesome/free-solid-svg-icons';
import '@fortawesome/react-fontawesome';
import '../queries-3df8abcc.js';
import '../permissions.js';
import '../queries-a3e6305b.js';
import '../ConfigProvider-9522944e.js';
import '../unauth-31a70615.js';
import './health/state.js';
import 'moment';
import '../proposal/health/state.js';
import '../view-breakup-99284a36.js';
import '../useFetchQuery-56ba5b94.js';
import '../useMutationQuery-42b53d8d.js';
import '@fortawesome/free-brands-svg-icons';
import '../icon-search-idle-a2977e92.js';
import '../ModalDownloadQuote.js';
import '../proposal/motor/state.js';
import '../state-cd3cac59.js';
import '../modal-transaction-lock-ed4d0501.js';
import '../system.config-53082f30.js';
import '../index-1a574785.js';
import '../common/intermediary/state.js';
import '../queries-5a111b86.js';
import '../modal-imd-search-7a00d2e1.js';
import '../ShortenString-21905b6b.js';
import '../state-74edd9f7.js';
import './motor/state.js';
import './fire/state.js';
import '../state-1fb1e261.js';
import './shopsecure/state.js';
import './workmenscompensation/state.js';
import '../state-a4d3dd58.js';
import '../state-0f17d715.js';
import '../state-92ba719e.js';
import '../state-f2888c41.js';
import '../proposal/fire/state.js';
import '../proposal/shopsecure/state.js';
import '../state-1686d318.js';
import '../policy/renewal/health/state.js';
import '../policy/renewal/motor/state.js';
import '../useFetchCacheQuery-88ef52f3.js';
import '../useCoversAndPlans-e373c56e.js';

var _templateObject, _templateObject2;
var QUERY_STATE = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query {\n    quoteIntermediary @client\n  }\n"])));
var QUERY_WIZARD_STATE = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query {\n    healthQuote @client\n  }\n"])));

function ChangeData(_ref) {
  var onUpdate = _ref.onUpdate;
  var repeatForMobile = 1;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: 2
  });

  var _useQuery = useQuery(QUERY_STATE),
      loading = _useQuery.loading,
      error = _useQuery.error,
      state = _useQuery.data;

  if (loading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error) return /*#__PURE__*/React.createElement(Error, null);
  var quoteIntermediary = state.quoteIntermediary;
  var intermediaryName = quoteIntermediary.intermediaryName,
      intermediaryCode = quoteIntermediary.intermediaryCode;
  var branchOffice = quoteIntermediary.branchOffice,
      fieldUser = quoteIntermediary.fieldUser,
      polInsOffice = quoteIntermediary.polInsOffice;
  var cdAccNo = quoteIntermediary.cdAccNo,
      cdAccBal = quoteIntermediary.cdAccBal;
  var initialValues = {
    intermediaryName: intermediaryName,
    intermediaryCode: intermediaryCode,
    branchOffice: branchOffice,
    fieldUser: fieldUser,
    polInsOffice: polInsOffice,
    cdAccNo: cdAccNo,
    cdAccBal: cdAccBal
  };

  var validate = function validate(values) {
    var errors = {};

    if (!values.intermediaryName) {
      errors.intermediaryName = 'Required';
    } else if (!values.intermediaryCode) {
      errors.intermediaryCode = 'Required';
    } else if (!values.branchOffice) {
      errors.branchOffice = 'Required';
    } else if (!values.fieldUser) {
      errors.fieldUser = 'Required';
    } else if (!values.polInsOffice) {
      errors.polInsOffice = 'Required';
    } else if (!values.cdAccNo) {
      errors.cdAccNo = 'Required';
    } else if (!values.cdAccBal) {
      errors.cdAccBal = 'Required';
    }

    return errors;
  };

  var onSubmit = function onSubmit(values) {
    updateIntermediary(values);
    onUpdate();
  };

  return /*#__PURE__*/React.createElement(QuantaFormik, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(Grid, {
    repeat: repeat,
    gapX: 8,
    className: "w-full p-2"
  }, /*#__PURE__*/React.createElement(QuantaInput, {
    label: "Intermediary Name",
    name: "intermediaryName",
    size: "full",
    type: "text"
  }), /*#__PURE__*/React.createElement(QuantaInput, {
    label: "Intermediary Code",
    name: "intermediaryCode",
    size: "full",
    type: "text"
  }), /*#__PURE__*/React.createElement(QuantaSelect, {
    label: "Branch Office",
    name: "branchOffice",
    size: "full",
    data: [{
      label: branchOffice,
      value: branchOffice
    }]
  }), /*#__PURE__*/React.createElement(QuantaInput, {
    label: "Field User",
    name: "fieldUser",
    size: "full",
    type: "text"
  }), /*#__PURE__*/React.createElement(QuantaSelect, {
    label: "Policy Insurance Office",
    name: "polInsOffice",
    size: "full",
    data: [{
      label: polInsOffice,
      value: polInsOffice
    }]
  }), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(QuantaInput, {
    label: "CD Account Number",
    name: "cdAccNo",
    size: "full",
    type: "text"
  }), /*#__PURE__*/React.createElement(QuantaInput, {
    label: "CD Account Balance",
    name: "cdAccBal",
    size: "full",
    type: "text"
  }), /*#__PURE__*/React.createElement(GridItem, {
    colSpan: repeat === repeatForMobile ? 1 : 2
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-4 flex flex-row justify-end"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "max-h-10",
    type: "submit"
  }, "Update"))))));
}

function IntermediaryLite() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showDetails = _useState4[0],
      setShowDetails = _useState4[1];

  var repeatForMobile = 1;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: 2
  });

  var _useQuery = useQuery(QUERY_STATE),
      loading = _useQuery.loading,
      error = _useQuery.error,
      state = _useQuery.data;

  var quoteIntermediary = state.quoteIntermediary;
  var intermediaryName = quoteIntermediary.intermediaryName,
      intermediaryCode = quoteIntermediary.intermediaryCode;
  var branchOffice = quoteIntermediary.branchOffice,
      fieldUser = quoteIntermediary.fieldUser,
      polInsOffice = quoteIntermediary.polInsOffice;
  var cdAccNo = quoteIntermediary.cdAccNo,
      cdAccBal = quoteIntermediary.cdAccBal;
  var data_lite = [{
    colSpan: 2,
    label: 'Partner Name',
    text: intermediaryName
  }, {
    label: 'Partner Code',
    text: intermediaryCode
  }, {
    text: /*#__PURE__*/React.createElement(Button, {
      flat: true,
      className: "mt-4 w-36 border-0 max-h-10",
      onClick: function onClick(e) {
        return setShowDetails(true);
      }
    }, "Show More")
  }];
  var data_detail = [{
    colSpan: 2,
    label: 'Partner Name',
    text: intermediaryName
  }, {
    colSpan: 2,
    label: 'Partner Code',
    text: intermediaryCode
  }, {
    label: 'Branch Office',
    text: branchOffice
  }, {
    colSpan: 2,
    label: 'Field User',
    text: fieldUser
  }, {
    colSpan: 2,
    label: 'Policy Insurance Office',
    text: polInsOffice
  }, {
    colSpan: 2,
    label: 'CD Account Number',
    text: cdAccNo
  }, {
    colSpan: 2,
    label: 'CD Account Balance',
    text: Parse(cdAccBal)
  }, {
    text: /*#__PURE__*/React.createElement(Button, {
      flat: true,
      className: "mt-4 w-36 max-h-10",
      onClick: function onClick(e) {
        return setShowModal(true);
      }
    }, "Change")
  }, {
    text: /*#__PURE__*/React.createElement(Button, {
      flat: true,
      className: "mt-4 w-36 border-0 max-h-10",
      onClick: function onClick(e) {
        return setShowDetails(false);
      }
    }, "Show Less")
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(Loading, null) : error ? /*#__PURE__*/React.createElement(Error, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    display: showModal,
    size: "".concat(repeat === repeatForMobile ? 'full' : 'medium'),
    title: "Change Partner",
    onClose: function onClose(e) {
      return setShowModal(false);
    }
  }, /*#__PURE__*/React.createElement(ChangeData, {
    onUpdate: function onUpdate() {
      setShowModal(false);
      document.body.classList.remove('overflow-y-hidden');
    }
  })), /*#__PURE__*/React.createElement(DataGrid, {
    data: showDetails ? data_detail : data_lite,
    textType: "normal",
    repeat: 2
  })));
}

function IntermediaryDetails() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var repeatForMobile = 1;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: 2
  });

  var _useQuery = useQuery(QUERY_STATE),
      loading = _useQuery.loading,
      error = _useQuery.error,
      state = _useQuery.data;

  if (state) {
    var quoteIntermediary = state.quoteIntermediary;
    var intermediaryName = quoteIntermediary.intermediaryName,
        intermediaryCode = quoteIntermediary.intermediaryCode;
    var branchOffice = quoteIntermediary.branchOffice,
        fieldUser = quoteIntermediary.fieldUser,
        polInsOffice = quoteIntermediary.polInsOffice;
    var cdAccNo = quoteIntermediary.cdAccNo,
        cdAccBal = quoteIntermediary.cdAccBal;
  }

  var data = [{
    label: 'Intermediary Name',
    text: intermediaryName
  }, {
    label: 'Intermediary Code',
    text: intermediaryCode
  }, {
    label: 'Branch Office',
    text: branchOffice
  }, {
    label: 'Field User',
    text: fieldUser
  }, {
    label: 'Policy Insurance Office',
    text: polInsOffice
  }, {
    label: 'CD Account Number',
    text: cdAccNo
  }, {
    label: 'CD Account Balance',
    text: Parse(cdAccBal)
  }, {
    text: /*#__PURE__*/React.createElement(Button, {
      flat: true,
      className: "mt-4 w-48 max-h-10",
      onClick: function onClick(e) {
        return setShowModal(true);
      }
    }, "Change")
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(Loading, null) : error ? /*#__PURE__*/React.createElement(Error, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    display: showModal,
    size: "".concat(repeat === repeatForMobile ? 'full' : 'medium'),
    title: "Change Intermediary",
    onClose: function onClose(_) {
      return setShowModal(false);
    }
  }, /*#__PURE__*/React.createElement(ChangeData, {
    onUpdate: function onUpdate() {
      setShowModal(false);
      document.body.classList.remove('overflow-y-hidden');
    }
  })), /*#__PURE__*/React.createElement(DataGrid, {
    data: data,
    textType: "normal",
    repeat: 1
  })));
}

function Summary() {
  var _useQuery = useQuery(QUERY_WIZARD_STATE),
      loading = _useQuery.loading,
      error = _useQuery.error,
      state = _useQuery.data;

  if (loading) return /*#__PURE__*/React.createElement(Loading, null);
  if (error) return /*#__PURE__*/React.createElement(Error, null);
  var healthQuote = state.healthQuote;
  var show_plans = healthQuote.show_plans;
  return show_plans ? /*#__PURE__*/React.createElement(IntermediaryLite, null) : /*#__PURE__*/React.createElement(IntermediaryDetails, null);
}

export { Summary as IntermediryDetails };
